import request from '@/utils/request';


// 获取信息
export function GetList(params) {
  return request({
    url: '/api/user/subApply/page',
    method: 'GET',
    params: params
  });
}

// 获取单位名称 
export function SearchUnit(params) {
  return request({
    url: '/api/user/subApply/searchUnit',
    method: 'GET',
    params: params
  });
}

// 获取pi列表
export function GetPiList(params) {
  return request({
    url: '/api/user/subApply/getPiList',
    method: 'GET',
    params: params
  });
}

// 解除绑定
export function Delete(params) {
  return request({
    url: '/api/user/subApply/delete',
    method: 'GET',
    params: params
  });
}

// 提交
export function Save(data) {
  return request({
    url: '/api/user/subApply/save',
    method: 'POST',
    data
  });
}

// 获取登录用户信息
export function GetUserInfo() {
  return request({
      url: '/api/user/info/getInfo',
      method: 'GET',
  });
}